var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":_vm.placeholder,"popper-append-to-body":false,"disabled":_vm.disabled},on:{"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }